import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Licenca",
  "description": "",
  "published": "2007-05-22T00:00:00.000Z",
  "redirect_from": ["/blog/licenca/swizec/204"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Odprotkodno programje je zabavna reÄ in rad v njej sodelujem, ker je, preprosto, zastonj izkušnja in napredek znanja v mojem poÄetju. Dobra naloÅ¾ba. Razumljivo je, da velike korporacije in nekateri drugi niso za odprto kodo in so celo zelo moÄno proti. Treba se je strinjati, da je delo mladine, da se upira, in delo velikih in moÄnih, da nasprotujejo temu uporu.`}</p>
    <p>{`Ker imam odprtokodni porjetk ali dva, sem si zaÄel ogledovati licenÄni del vsega skupaj. Obstajajo oÄitni problemi z `}<a parentName="p" {...{
        "href": "http://www.opensource.org/licenses/gpl-license.php"
      }}>{`GPL-jem`}</a>{`, saj je viralna licenca, ki se širi kot herpes. Kadarkoli projekt poljubi drugega oba konÄata s herpesom`}</p>
    <p>{`V nasprotju temu je v mojem delu veliko primerov, ko grem proti GPL-ju zaradi pogodb s strankami, da bi za svoje delo dobil povraÄila. Saj pravzaprav razvijam nekaj za dotiÄno stranko, za dotiÄno rabo po njihovih specifikacijah in zahtevah. ÄŒeprav mi je sÄasoma dovoljeno kodo spustiti v divjino, tega ne Å¾elijo takoj.`}</p>
    <p>{`Projekte je teÅ¾ko razvijati s tal in zaradi tega imam svoj set lego kock, ki delo olajšajo, a so vse v krempljih GPL-ja in tako potencialno nevarne. Do sedaj sem deloval v nasprotju z licenco ter se tako izognil prevelikim teÅ¾avam, vendar se to ne sme. Kaj mi je torej drugega storiti, kot poiskatu drugaÄno licenco? IzkaÅ¾e se, da problem tiÄi v grmu, ki se mu reÄe `}<a parentName="p" {...{
        "href": "http://www.opensource.org/licenses/category"
      }}>{`ogromno število popolnoma nerazumljivih licenc`}</a>{` v odvetniški govorici. ÄŒisto izven moje sposobnosti dojemanja.`}</p>
    <p>{`Tako je odgovor, da je paÄ potrebno ustvariti svojo licenco, ki mi bo ustrezala. Da pa se to stori so pa potrebni odvetniki, ki idejo prevedejo v nekaj njim razumljivega. Le-ti se hranijo zu denarjem. Denarjem, ki ga ni. Tu je teÅ¾ava.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      